import React from 'react';
import { IconPictoOphelie, IconSize } from '@axafr-btc-ds/icons';
import { TextSM } from '@axafr-btc-ds/typography';
import { cssIconFloating, messageContainer, messageContent } from './css';
import { cx } from '@emotion/css';
export var MessageOphelie = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("article", { className: cx(className, messageContainer) },
        React.createElement(IconPictoOphelie, { size: IconSize.x4, className: cssIconFloating }),
        React.createElement(TextSM, { component: "p", className: messageContent }, children)));
};
